var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {}, [
      _vm._v(
        " Para anular este proceso de aprobación debes realizarlo bajo la seguridad del 2FA o Cód. de verificación "
      )
    ]),
    _c(
      "div",
      { staticClass: "wrap-option" },
      [
        _c(
          "vs-radio",
          {
            attrs: { "data-cy": "2FA-(OTP)", "vs-value": "twoFa" },
            model: {
              value: _vm.cancel.typeCancel,
              callback: function($$v) {
                _vm.$set(_vm.cancel, "typeCancel", $$v)
              },
              expression: "cancel.typeCancel"
            }
          },
          [_vm._v("2FA (OTP) ")]
        ),
        _c(
          "vs-radio",
          {
            attrs: { "vs-value": "internCode" },
            model: {
              value: _vm.cancel.typeCancel,
              callback: function($$v) {
                _vm.$set(_vm.cancel, "typeCancel", $$v)
              },
              expression: "cancel.typeCancel"
            }
          },
          [_vm._v(" Código de Verificación ")]
        )
      ],
      1
    ),
    _vm.cancel.typeCancel === "internCode"
      ? _c(
          "div",
          { staticClass: "wrap-form" },
          [
            _c(
              "vs-row",
              [
                _c(
                  "vs-col",
                  {
                    attrs: {
                      "vs-type": "flex",
                      "vs-justify": "center",
                      "vs-align": "center",
                      "vs-w": "6"
                    }
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          disabled: _vm.gettingCode,
                          size: "sm",
                          variant: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.getCode()
                          }
                        }
                      },
                      [_vm._v(" Solicitar código ")]
                    )
                  ],
                  1
                ),
                _c(
                  "vs-col",
                  {
                    attrs: {
                      "vs-type": "flex",
                      "vs-justify": "center",
                      "vs-align": "center",
                      "vs-w": "6"
                    }
                  },
                  [
                    _c("vs-input", {
                      attrs: {
                        maxlength: "8",
                        label: "Código de Verificación",
                        "data-cy": "cancel-code"
                      },
                      model: {
                        value: _vm.cancel.code,
                        callback: function($$v) {
                          _vm.$set(_vm.cancel, "code", $$v)
                        },
                        expression: "cancel.code"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm.cancel.typeCancel === "twoFa"
      ? _c(
          "div",
          { staticClass: "wrap-form" },
          [
            _c("vs-input", {
              attrs: {
                "data-cy": "otp-code",
                maxlength: "8",
                label: "Código de Verificación"
              },
              model: {
                value: _vm.cancel.code,
                callback: function($$v) {
                  _vm.$set(_vm.cancel, "code", $$v)
                },
                expression: "cancel.code"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.error.message !== ""
      ? _c(
          "div",
          {
            staticClass:
              "con-text-validation span-text-validation-danger\n        vs-input--text-validation-span v-enter-to text-right",
            staticStyle: { height: "32px" }
          },
          [
            _c("span", { staticClass: "span-text-validation" }, [
              _vm._v(" " + _vm._s(_vm.error.message) + " ")
            ])
          ]
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "mt-4 text-center" },
      [
        _c(
          "b-button",
          {
            attrs: { "data-cy": "override-process", variant: "primary" },
            on: {
              click: function($event) {
                return _vm.cancelFile()
              }
            }
          },
          [_vm._v(" Anular Proceso ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }